import BranchAgentServiceTimePerService from "../../../components/branches/reports/daily/BranchAgentServiceTimePerService";
import DailyGeneratedReportPage from "../../../components/reports/DailyGeneratedReportPage";
import { REPORT_TYPE_IDS } from "../../../store/constants";
import { AGENT_SERVICE_TIME_COLUMN_DEFINITIONS } from "../../../store/renderConfig";

const DailyBranchAgentServiceTimePerService = ({ showFilterForm = true, showTitle = 1 }) => (
  <DailyGeneratedReportPage
    branchScoped={true}
    reportTypeId={REPORT_TYPE_IDS.daily_branch_agent_service_time_per_service}
    title="Agent Service Time Per Service"
    helmetTitle="Daily Branch Agent Service Time Per Service"
    descriptionKey="AgentServiceSessionTime"
    columnDefinitions={AGENT_SERVICE_TIME_COLUMN_DEFINITIONS}
    defaultSortColumn="ticketCount"
    showFilterForm={showFilterForm}
    showTitle={showTitle}
  >
    {({ data, renderConfig, onRenderConfigChange }) => (
      <BranchAgentServiceTimePerService
        data={data}
        renderConfig={renderConfig}
        onRenderConfigChange={onRenderConfigChange}
      />
    )}
  </DailyGeneratedReportPage>
);

export default DailyBranchAgentServiceTimePerService;
